export default __webpack_public_path__ + "static/media/pig.ed23e3f2.m4a";